import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import EmailMessageThreadForm from '../../../components/forms/EmailMessageThreadForm';
import { useEmailMessageThreadApi } from '../../../hooks/useEmailMessageThreadApi';
import { useNavigate } from 'react-router-dom';
import { EmailMessageThreadDTO } from '../../../services/apiClient';

const EmailMessageThreadCreate: React.FC = () => {
  const { create, isLoading } = useEmailMessageThreadApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Email Message Threads', href: '/admin/emailmessagethreads' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: EmailMessageThreadDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/emailmessagethreads');
    } catch (error) {
      console.error('Error creating EmailMessageThread:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/emailmessagethreads"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Manage.EmailMessageThread.Edit'
    >
        <EmailMessageThreadForm
          initialValues={{} as EmailMessageThreadDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/emailmessagethreads')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default EmailMessageThreadCreate;